export default {
    rules: state => state.rules
}
